import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AppTheme } from '@/types';

const THEME_STORAGE_KEY = 'smarthub-theme';

function applyThemeToDom(theme: AppTheme) {
  document.documentElement.setAttribute('data-theme', theme);
}

function getInitialTheme(): AppTheme {
  const stored = localStorage.getItem(THEME_STORAGE_KEY) as AppTheme | null;
  if (stored === 'dark' || stored === 'light') return stored;
  // Respect system preference as fallback
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

// Apply theme immediately to avoid FOUC
const initialTheme = getInitialTheme();
applyThemeToDom(initialTheme);

interface ThemeState {
  current: AppTheme;
}

const initialState: ThemeState = {
  current: initialTheme,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<AppTheme>) {
      state.current = action.payload;
      localStorage.setItem(THEME_STORAGE_KEY, action.payload);
      applyThemeToDom(action.payload);
    },
    toggleTheme(state) {
      const next: AppTheme = state.current === 'dark' ? 'light' : 'dark';
      state.current = next;
      localStorage.setItem(THEME_STORAGE_KEY, next);
      applyThemeToDom(next);
    },
  },
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
